import { connectToRealChatJessWebSocket } from "./connectToRealChatJessWebSocket";
import { ChatJessWebSocketEvent } from "../../pages/Dashboard/ChatJess/types";
import { logger } from "../../utils/logger";

/**
 * Connects to the ChatJess WebSocket server
 * This is the main entry point for ChatJess WebSocket connections
 */
export const connectToChatJessWebSocket = (
  onMessage: (event: ChatJessWebSocketEvent) => void,
  onConnectionChange?: (connected: boolean) => void,
  onError?: (error: Error) => void,
): WebSocket => {
  return connectToRealChatJessWebSocket(onMessage, onConnectionChange, onError);
};

// Re-export utility functions for easier access
export {
  disconnectChatJessWebSocket,
  getCurrentChatJessWebSocket,
  isChatJessWebSocketConnected,
} from "./connectToRealChatJessWebSocket";
